import React from 'react'
import { Box, type BoxProps } from '@mui/material'

import Typography from '~/components/elements/Typography/Typography'

type TypographyComponent = (typeof Typography)[keyof typeof Typography]
interface LabelValueProps {
  ContainerProps?: BoxProps
  LabelComponent?: TypographyComponent
  LabelProps?: any
  ValueComponent?: TypographyComponent
  ValueProps?: any
  label: string
  value: React.ReactNode
}

export const LabelValue = ({
  label,
  value,
  LabelComponent = Typography.H3,
  ValueComponent = Typography.ParagraphSm,
  ContainerProps = {},
  LabelProps = {},
  ValueProps = {},
}: LabelValueProps) => (
  <Box
    alignItems="baseline"
    component="dl"
    display="flex"
    flexDirection="row"
    gap={1}
    m={0}
    {...ContainerProps}
  >
    <LabelComponent as="dt" {...LabelProps}>
      {label}
    </LabelComponent>
    <ValueComponent as="dd" {...ValueProps}>
      {value}
    </ValueComponent>
  </Box>
)
